import { render, staticRenderFns } from "./HomeTrainTab.vue?vue&type=template&id=0be95707"
import script from "./HomeTrainTab.vue?vue&type=script&lang=js"
export * from "./HomeTrainTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports